import React from 'react'
import { Form } from "react-bootstrap"

const TextAreaField = ({name, rows, placeholder, required, handlechange, fieldClass, label, grpmd}) => (
  <Form.Group controlId="validation{name}">
    { label
      ? <Form.Label>{label}{required ? '*' : ''}</Form.Label>
      : ''
    }
    <Form.Control
      className={fieldClass}
      name={name}
      required={required}
      as="textarea"
      rows={rows}
      onChange={handlechange}
      placeholder={placeholder} 
    />
  </Form.Group>
);

export default TextAreaField;